// extracted by mini-css-extract-plugin
export default {"container":"BI_CuD","registrationButtonSpacing":"Zzi0W3"};